import type { AxiosError, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';

import { ApiError } from '../models';
import { ClientAppConfig } from '../types/ClientAppConfig';

export interface FetcherProps extends Pick<ClientAppConfig, 'tenant'> {
  token: string;
}

export async function fetcher<T>(url: string, options: AxiosRequestConfig & FetcherProps): Promise<T> {
  const { tenant, token, ...config } = options;
  const headers: AxiosRequestHeaders = {
    ...config.headers,
    authorization: token,
    'x-tenant-context': tenant,
  };

  return axios
    .get<T>(`${url}`, {
      ...config,
      headers,
    })
    .then(({ data: result }) => result)
    .catch((error: AxiosError<T>) => {
      throw new ApiError(error.message, error);
    });
}
